export const AUTOMATION_IDS = {
  CONTAINER: 'attach-highlight-container',
  LABEL: 'attach-highlight-label',
};
